const useCardsAnalytics = () => true;

export default useCardsAnalytics;
